import { render, staticRenderFns } from "./ClientHealth.vue?vue&type=template&id=31d22580&scoped=true&"
import script from "./ClientHealth.vue?vue&type=script&lang=ts&"
export * from "./ClientHealth.vue?vue&type=script&lang=ts&"
import style0 from "./ClientHealth.vue?vue&type=style&index=0&id=31d22580&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d22580",
  null
  
)

export default component.exports